<template>
  <span
    class="badge badge-success"
    :class="{
      'badge-warning': daysTillExpired <= 42,
      'badge-danger': daysTillExpired <= 28,
      blink: daysTillExpired <= 28
    }"
    v-if="minDaysToShow === null || minDaysToShow >= daysTillExpired"
  >
    <span v-if="show === 'days'">{{ daysTillExpired }} days</span>
    <span v-if="show === 'date'">{{ expiryDate | date }}</span>
  </span>
</template>

<script>
export default {
  props: {
    expiryDate: {
      required: true
    },
    show: {
      type: String,
      default: 'days'
    },
    minDaysToShow: {
      type: Number,
      default: null
    }
  },
  computed: {
    daysTillExpired() {
      const today = new Date().getTime()
      const expiryDate =
        this.expiryDate instanceof Date ? this.expiryDate.getTime() : new Date(this.expiryDate).getTime()
      return Math.ceil((expiryDate - today) / (1000 * 3600 * 24))
    }
  },
  filters: {
    date(date) {
      if (!(date instanceof Date)) date = new Date(date)
      return new Date(date).toLocaleDateString('de-de', {
        day: '2-digit',
        month: '2-digit',
        year: 'numeric'
      })
    }
  }
}
</script>
